<template>
  <vs-button
    class="revoke-button cursor-pointer"
    :type="type"
    :color="color"
    :style="buttonStyle"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
    @click="onClick"
    :disabled="disabled"
  >
    <span class="revoke-text aisea-text-16-400-dark-gray whitespace-no-wrap">{{
      text
    }}</span>
  </vs-button>
</template>

<script>
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

const EVENTS = {
  CLICK: "click",
};

export default {
  name: "RevokeButton",

  props: {
    text: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: AISEA_COLOR.DARK_GRAY,
    },
    type: {
      type: String,
      default: "border",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    };
  },

  computed: {
    buttonStyle() {
      return {
        "box-shadow": "none",
        background: "none",
        backgroundColor: this.isHover
          ? AISEA_COLOR.WHITE
          : AISEA_COLOR.PURE_WHITE,
      };
    },
  },

  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.revoke-button {
  &.vs-button {
    width: 282px;
    height: 60px;
    padding: 16px 136px;

    ::v-deep .vs-button-backgroundx.vs-button--background {
      display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
    }
  }
}
</style>
